<template>
  <!--                   表头日期组件                           -->
  <!--  :style="{'margin-left':-cellWidth/2+'px'}" -->
  <div class="gantt-timeline">
    <!--class="gantt-timeline-block"-->
    <div v-for="(item,index) in getDays"
         :style="{width:getTimeScales(item.day).length*cellWidth+'px'}"
         :class="item.isWork ?'gantt-timeline-holidayBlock':'gantt-timeline-block'"
         :key="index">
      <div class="gantt-timeline-day "
           :style="heightStyle">
        {{item.day.format("YY-MM-DD")}}</div>
      <div class="gantt-timeline-scale "
           :style="heightStyle">
        <div :style="cellWidthStyle">
          <!--          <div>{{day.format("DD")}}</div>-->
          <div>{{getWeekStr(item.day)}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import dayjs from "dayjs";
import { getBeginTimeOfTimeLine } from "../../../../../utils/timeLineUtils.js";

const START_DAY = Symbol();
const MIDDLE_DAY = Symbol();
const END_DAY = Symbol();

function isSameDay (one, two) {
  return one.isSame(two, "day");
}

export default {
  name: "Timeline",

  props: {
    start: {
      type: dayjs
    },
    end: {
      type: dayjs
    },
    cellWidth: {
      type: Number
    },
    titleHeight: {
      type: Number
    },
    scale: {
      type: Number
    },
    subHolidayList: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    /**
     * 天列表
     * @returns {[dayjs]} 该data中所有需要渲染的数据
     */
    getDays () {
      let temp = [];
      let { start, end } = this;
      let itemdata = '' // 接收map中的值
      // 创建个新map 用来存放公共假期的数据
      const holidayMap = new Map()
      if (this.subHolidayList) {
        for (let m of this.subHolidayList) {
          holidayMap.set(m.calendarDate, m) // map 键，值对的形式，通过set存
        }
        for (; !isSameDay(start, end); start = start.add(1, "day")) {
          let key = start.format('YYYY-MM-DD 00:00:00')
          // 判断key是否存在map中
          if (holidayMap.has(key)) {
            // 通过key键去取map中的值
            itemdata = holidayMap.get(key)
            // 如果是休息日，push到temp数组isWork:true，否则为false
            if (itemdata.isWorkday === 'NO') {
              temp.push({
                day: start,
                isWork: true
              });
            } else {
              temp.push({
                day: start,
                isWork: false
              })
            }
          } else {
            //将[start,end]区间中没有在公共假期数组中的数据push进temp中，表头需要是[start,end]这个区间
            temp.push({
              day: start,
              isWork: false
            })
          }
        }
        // 存最后一个日期
        temp.push({
          day: start,
          isWork: false
        })
      } else {
        for (; !isSameDay(start, end); start = start.add(1, "day")) {
          temp.push({
            day: start,
            isWork: false
          });
        }
        temp.push({
          day: start,
          isWork: false
        });
      }
      return temp;
    },
    cellWidthStyle () {
      return {
        width: `${this.cellWidth}px`
      };
    },
    heightStyle () {
      return {
        height: this.titleHeight / 2 + "px",
        "line-height": this.titleHeight / 2 + "px"
      };
    }
  },

  methods: {
    /**
     * 星期
     * @returns
     */
    getWeek (weekNum) {
      let str = '星期';
      switch (weekNum) {
        case 0:
          str += "日";
          break;
        case 1:
          str += "一";
          break;
        case 2:
          str += "二";
          break;
        case 3:
          str += "三";
          break;
        case 4:
          str += "四";
          break;
        case 5:
          str += "五";
          break;
        case 6:
          str += "六";
          break;
        default:
          throw new TypeError("获取星期错误");
      }
      return str;
    },

    getWeekStr (date) {
      return this.getWeek(date.day())
    },

    /**
     * 获取时间刻度数组
     *
     * @param {dayjs} date
     * @returns {[string]} 该data中所有需要渲染的数据
     */
    getTimeScales (date) {
      let { start, end } = this;

      if (isSameDay(date, start)) {
        // eslint-disable-next-line
        return this.generateTimeScale(START_DAY);
      } else if (isSameDay(date, end)) {
        // eslint-disable-next-line
        return this.generateTimeScale(END_DAY);
      } else {
        // eslint-disable-next-line
        return this.generateTimeScale(MIDDLE_DAY);
      }
    },
    /**
     * 生成时间刻度数组
     *
     * @param {Symbol} type
     * @returns {[string]} 该data中所有需要渲染的数据
     */
    generateTimeScale (type) {
      let totalblock = [];
      let { start, end, scale } = this;
      let a, b;
      switch (type) {
        case START_DAY: //和start同一天
          a = getBeginTimeOfTimeLine(start, scale);
          //start和end同一天特殊处理
          if (isSameDay(start, end)) {
            b = end;
          } else {
            b = start.endOf("day");
          }
          break;
        case END_DAY: //和end 同一天
          a = end.startOf("day");
          b = end;
          break;
        case MIDDLE_DAY: //start和end中间的天
          a = start.startOf("day");
          b = start.endOf("day");
          break;
        default:
          throw new TypeError("错误的计算类型");
      }
      while (!a.isAfter(b)) {
        if (scale >= 60) {
          totalblock.push(a.format("HH"));
        } else {
          totalblock.push(a.format("HH:mm"));
        }
        a = a.add(scale, "minute");
      }

      return totalblock;
    }
  }
};
</script>
<style scoped>
/* 节假日的样式 */
.gantt-timeline-holidayBlock {
  background-image: linear-gradient(
    to top,
    rgb(153, 152, 152),
    rgb(160, 157, 157)
  );
  width: 20px;
  height: 60px;
}
.gantt-timeline-scale {
  border-top: 1px solid #dcdee3;
}
</style>